import React from "react";
import { Container, Row, Col } from "reactstrap";
import VideoList from "./VideoList";

const Videos = () => {
  return (
    <Container fluid className="p-0">
      <h1 className="page-title">Cognitive Videos</h1>
      <Row>
        <Col lg="12" className="d-flex">
          <VideoList />
        </Col>
      </Row>
    </Container>
  );
};

export default Videos;
